module.exports = __webpack_public_path__ + "img/Flaticon.c0aa6c60.svg";